import {
    Backdrop,
    Chip,
    Card,
    CardContent,
    CardHeader,
    Container,
    Box,
    Grid,
    DialogContent,
    DialogTitle, Slide, Stack,
    Table,
    TableBody,
    TableContainer, TableHead,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { LoadingButton } from "@mui/lab";
import useLocalStorage from "src/shared/hooks/useLocalStorage";
import AuthService from "src/core/access-control/AuthService";
// import { StyledTableCell, StyledTableRow } from "../../../../shared/sections/@dashboard/tableStyle/tableBody";
import { FormProvider, RHFTextField } from "../../../shared/components/hook-form";
import { fCurrency } from "src/shared/utils/formatNumber";
import call from "src/core/services/http";
import BillNumberConstants from "src/shared/reducers/BillNumber/BillNumberConstants";
import TransactionConstants from '../../transactions/store/TransactionConstants';

// import TransactionsReducer from "../../store/TransactionReducer";
// import TransactionsStatementConstants from "src/packages/transactionsStatement/store/TransactionsStatementConstants";
  

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const SendMoneySchema = Yup.object().shape({
    sacco_sasapay_account_number: Yup.string().required('sacco account is required'),
    beneficiary_account_number: Yup.string().required('Beneficiary account is required'),
    amount: Yup.string().required('Provide an amount'),
});

const defaultValues = {
    sacco_sasapay_account_number: "",
    beneficiary_account_number: "",
    amount: "",
};


export default function SendMoney() {


    const [shop] = useLocalStorage('shop-details');
    const { controlAccounts } = useSelector(state => state.transactions)
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)


    const methods = useForm({
        resolver: yupResolver(SendMoneySchema),
        defaultValues,
    });


    const { handleSubmit, reset, setValue, getValues, formState: { isSubmitting } } = methods;

    // Search bill number
    const [searchingBillNumber, setSearchingBillNumber] = useState("")
    const [billNumber, setBillNumber] = useState("")
    const [sendTo, setSendTo] = useState(null)
    const [errorMessage, setErrorMessage] = useState("")
    const [searchedSuccess, setSearchedSuccess] = useState(false)

    const searchBillNumber = async () => {
        if (billNumber === "") {
            setErrorMessage("Paybill/Till number is required")
        }
       
        else {
            setSearchingBillNumber(true)
            const response = await call('post', TransactionConstants.MERCHANTCODE, { bill_number: billNumber })
            setSearchingBillNumber(false)
            if (response.data.status) {
                setValue("recipient_account_number", billNumber)
                setSendTo(`Send money to ${response.data.merchant.description}`)
                setSearchedSuccess(true)
            }
         //   console.log(response)
            else {
              
                toast.error(response.data.message)} 
        }

    }
    const [completedMessage, setCompletedMessage] = useState("")
    const [confirmMessage, setConfirmMessage] = useState("")

 
    const onSubmit = async () => {
        try {
          setLoading(true); // Start loading
          const { amount, sacco_sasapay_account_number, beneficiary_account_number } = getValues();
    
          const payload = {
            merchant_account_number: shop.account_number,
            sacco_sasapay_account_number,
            beneficiary_account_number,
            amount,
          };
    
          const res = await call("post", `/transfers/send-sacco-payment/`, payload);
    
          if (res.data.status) {
            toast.success(res.data.message);
            setCompletedMessage(res.data.message); // Set completion message for display (if needed)
            reset(defaultValues); // Clear the form
          } else {
            toast.error(res.data.message);
          }
        } catch (error) {
          console.error("Error submitting form:", error);
        } finally {
          setLoading(false); // Stop loading
        }
      };

  

    return (
        <Container maxWidth='xl'>
            {/* <ToastContainer theme={"colored"} /> */}

            <Grid container rowSpacing={1} columnSpacing={{ xs: 12, sm: 12, md: 3 }}>
                <Grid item sx={{ xs: { display: 'none' }, lg: { display: 'block' } }} lg={4}></Grid>
                <Grid item xs={12} md={5} lg={4}>
                    <Card>
                        <CardContent>
                     
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                <Stack spacing={2} mt={2}>
                                        <RHFTextField
                                        size={'medium'}
                                        name="sacco_sasapay_account_number"
                                        label='Sacco Account Number'
                                       
                                        
                                           />
                                        <RHFTextField size={'medium'} name="beneficiary_account_number" label='Beneficiary Account Number ' />
                                        <RHFTextField size={'medium'} name="amount" label='Amount' />
                                        <Stack direction={{ sm: 'column', md: 'row' }} spacing={5} alignContent='space-between'>
                                        <LoadingButton
                                            onClick={onSubmit}
                                            loading={loading}
                                            fullWidth
                                            size="medium"
                                            type="submit"
                                            variant='contained'
                                            color='primary'
                                        >
                                            Submit
                                        </LoadingButton>
                                        </Stack>
                                </Stack>
                            </FormProvider>
                          
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
           
        </Container>
    )
}